var OCS = OCS || {};
OCS.Functions = OCS.Functions || {};
OCS.Functions.get_domain = function () {
    var ocs_domain = OCS.domain;
    if (!ocs_domain) {
        ocs_domain = document.domain.split('.');
        if (ocs_domain.length > 1) {
            ocs_domain = ocs_domain.shift();
        }
        ocs_domain = ocs_domain.join('.');
    }
    return ocs_domain;
};
OCS.Functions.get_feeds_domain = function () {
    return (OCS.ENVIRONMENT === 'PRODUCTION') ? 'feeds.prod.mesonet.org' : (OCS.ENVIRONMENT === 'STAGING') ? 'feeds.test.mesonet.org' : 'feeds.dev.ok.mesonet.us';
};
OCS.Functions.is_edge = function () {
    return (new RegExp("Edge").exec(navigator.userAgent) !== null);
};
OCS.Functions.is_ie = function () {
    return ((navigator.appName === 'Microsoft Internet Explorer') || ((navigator.appName === 'Netscape') && (new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})").exec(navigator.userAgent) !== null)));
};
